<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23 44V81H77V44" stroke="black" stroke-width="4"/>
<path d="M10 57C10 57 34.379 32.621 50 17L90 57" stroke="black" stroke-width="4"/>
<rect x="40" y="59" width="20" height="22" stroke="black" stroke-width="4"/>

<g>
<rect x="57" y="19" width="30" height="31" fill="white"/>
<path d="M62 32.5H85" stroke="black" stroke-width="4"/>
<path d="M73.5 21L73.5 44" stroke="black" stroke-width="4"/>
</g>

</svg>

</template>
